module.exports = "h4{\n    padding-top:10px;\n    padding-left:10px;\n}"